import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SessionBaseComponent } from '../../../../shared/components/session.base.component';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { RfqCreationService } from '../../service/rfq-creation.service';
import { Dropdown } from 'primeng/dropdown';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { RfqSettingService } from '../../service/rfq-setting.service';
import { LaasOption } from 'src/app/core/models/laas-option';

@Component({
  selector: 'laas-rfq-header-detail',
  templateUrl: './rfq-header-detail.component.html',
  styleUrls: ['./rfq-header-detail.component.scss']
})
export class RfqHeaderDetailComponent extends SessionBaseComponent implements OnInit {

  rfqData : any;
  rfqDetail : any;
  bookingForwarderOptions : any[] = [];
  rfqStatusOptions : any[] = [];
  shipTermOptions: LaasOption[] = [];
  rfqCategoryTypeOptions : any[] = [];
  pickupLocationOptions : any[] = [];
  yesNoOption: any[] = [];
  customerOptions : any[] = [];
  countryOptions : any[] = [];
  allCityOptions: any[] = [];
  allAreaOptions: any[] = [];
  expressTermOptions : any[] = [];
  shippingTypeOptions : any[] = [];
  feeTypeOptions : any[] = [];
  calculationUnitOptions : any[] = [];
  detailList : any[] = [];
  detailColumns : any[] = [];
  disableEditBtn : boolean = true;
  headerRemark: any;
  isCanEditRemark: boolean;

  constructor(
    injector: Injector,
    private rfqCreationService : RfqCreationService,
    private commonDataService: CommonDataService,
    private facilityService : FacilityService,
    private notificationSubScriptionService : NotificationSubScriptionService,
    private dropdownOptionsService: DropdownOptionsService,
    private rfqSettingService : RfqSettingService,
    private fb: FormBuilder
  ) {

    super(injector);
    this.headerRemark = null;
    this.isCanEditRemark = false;

    this.detailColumns = [
      { field: 'feeType', header: 'RFQPreview.SubTable.CostType' },
      { field: 'incoTerm', header: 'RFQPreview.SubTable.TradeTerm' },
      { field: 'shippingSectionDesc', header: 'RFQPreview.SubTable.TransportSectionDescription' },
      { field: 'currency', header: 'RFQPreview.SubTable.AccountingCurrency' },
      { field: 'unitPrice', header: 'RFQPreview.SubTable.UnitPrice' },
      { field: 'calculationUnit', header: 'RFQPreview.SubTable.CalculationUnit' },
      { field: 'intervalUnitStart', header: 'RFQPreview.SubTable.CalculationRangeStart' },
      { field: 'intervalUnitEnd', header: 'RFQPreview.SubTable.CalculationRangeEnd' },
      { field: 'minimalCharge', header: 'RFQPreview.SubTable.MinimumCost' },
      { field: 'remark', header: 'RFQPreview.SubTable.Remarks' },
      { field: 'isTieredGroup', header: 'RFQPreview.SubTable.IsRFQ' },
    ];

  }

  async ngOnInit(): Promise<void> {

    await super.ngOnInit();

    console.log("this.routeStateService.getCurrent().data:", this.routeStateService.getCurrent().data);
    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    this.rfqData = await  this.rfqSettingService.getRfq(seqNo);
    this.rfqDetail = await this.rfqSettingService.getRfqDetail(seqNo);
    const facility = this.laasSetting.facility;
    this.headerRemark = this.rfqData?.remark;

    this.facilityService.getForwarderOptions(facility).subscribe({
      next: result => {
        this.bookingForwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
      complete: () => {
      }
    });


    this.dropdownOptionsService.getRFQStatusOptions()
    .subscribe({
      next: (options: any[]) => {
        this.rfqStatusOptions = options.map(x => ({ label: x.optionDesc, value: Number(x.optionCode) }));
      }
    });

    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.shipTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
          this.shipTermOptions.unshift({
            label: 'ALL',
            value: 'ALL'
          });
        }
      });

    //
    this.dropdownOptionsService.getVCountryOptions()
    .subscribe({
      next: (options: any[]) => {
        this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
        this.countryOptions.unshift({
          label: 'ALL',
          value: 'ALL'
        });
      }
    });

    //
    this.dropdownOptionsService.getVCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.allCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString() , country: x.country }));
        this.allCityOptions.unshift({
          label: 'ALL',
          value: 'ALL'
        });
      }
    });

    //
    this.dropdownOptionsService.getVAreaOptions()
    .subscribe({
      next: (options: any[]) => {
        this.allAreaOptions = options.map(x => ({ label: x.areaName, value: x.areaCode , city : x.city }));
      }
    });

    this.dropdownOptionsService.getRfqCategoryTypeOptions()
    .subscribe({
      next: (options: any[]) => {
        this.rfqCategoryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getPickupLocationOptions()
    .subscribe({
      next: (options: any[]) => {
        this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.dropdownOptionsService.findFacilityOptionsByOptionType("ExpressTerm")
    .subscribe({
      next: (options: any[]) => {
        this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.findFacilityOptionsByOptionType("ShippingType")
    .subscribe({
      next: (options: any[]) => {
        this.shippingTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.dropdownOptionsService.findFeeTypeByFeeTypeCategory("RFQ")
      .subscribe({
      next: (options: any[]) => {
        this.feeTypeOptions = options.map(x => ({ label: x.feeTypeName, value: x.feeTypeCode }));
      }
    });


    this.dropdownOptionsService.findFacilityOptionsByOptionType("CalculationUnit")
      .subscribe({
      next: (options: any[]) => {
        this.calculationUnitOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];


    if(this.rfqData.status == 1 ){
      this.disableEditBtn = false;
    }

    if (this.permissionCodes.includes(PermissionConstants.EditRFQRemark)) {
      this.isCanEditRemark = true;
    }
  }


  editBtn(){
    console.log("editBtn");
    const seqNo = this.routeStateService.getCurrent().data.seqNo;
    this.routeStateService.navigateTo('/Setting/RfqHeaderEdit', seqNo , false);
  }

  updateRemarkBtn() {
    this.rfqData.remark = this.headerRemark;
    let obj = {rfqEntity : this.rfqData , rfqDetailEntity : this.rfqDetail };

    this.confirmationService.confirm({
      message: this.translateService.instant('RFQSetting.Confirm.ConfirmEditRFQ'),
      header: 'EDIT',
      rejectVisible: true,
      accept: () => {
        this.loader.show();
        this.rfqSettingService.updateRfq(obj)
        .subscribe({
          next: async result => {
            const seqNo = this.routeStateService.getCurrent().data.seqNo;
            this.rfqData = await this.rfqSettingService.getRfq(seqNo);
            this.rfqDetail = await this.rfqSettingService.getRfqDetail(seqNo);
            this.toastService.info(this.translateService.instant('RFQSetting.Info.UpdateSuccess'));
            this.loader.hide();
          },
          error: (err: any) => {
            this.toastErrorMessage(err.error);
          }
        });

      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }


}
